import { render, staticRenderFns } from "./BinComponent.vue?vue&type=template&id=56f45dfc&scoped=true"
import script from "./BinComponent.vue?vue&type=script&lang=js"
export * from "./BinComponent.vue?vue&type=script&lang=js"
import style0 from "./BinComponent.vue?vue&type=style&index=0&id=56f45dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f45dfc",
  null
  
)

export default component.exports